import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
})
export class InputComponent implements OnInit {
  @Input() option;
  @Output() valueEmit = new EventEmitter();

  constructor() {}

  @HostListener('input', ['$event'])
  emitValue(event: any) {
    if (this.option?.trim) {
      event.target.value = event.target.value.replace(/\s+/g, '');
      this.valueEmit.emit(event.target.value.replace(/\s+/g, ''))
    } else {
      this.valueEmit.emit(event.target.value);
    }
  }

  ngOnInit(): void {}
}
